<sim-basic-material-dialog
	(closeClicked)="close({action: 'cancel'})"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-qrcode', fontSet: 'fad'}"
	[headerText]="'Device ID Qr-Code'"
	[matDialogData]="data"
	[rect]="rect"
	[smallHeader]="true"
>
	<div dialogContent>
		@if (themeService.isDarkTheme()) {
			<qrcode
				[qrdata]="deviceService.device().deviceId"
				[colorLight]="'#042631'"
				[colorDark]="'#ffffff'"
				[imageSrc]="'./assets/icons/logoForQRCode.svg'"
				[imageHeight]="50"
				[imageWidth]="50"
				[width]="200"
			></qrcode>
		} @else {
			<qrcode
				[qrdata]="deviceService.device().deviceId"
				[colorLight]="'#f5f5f5'"
				[colorDark]="'#000000'"
				[imageSrc]="'./assets/icons/logoForQRCodeLight.svg'"
				[imageHeight]="50"
				[imageWidth]="50"
				[width]="200"
			></qrcode>
		}
	</div>
</sim-basic-material-dialog>
